import * as FingerPrint from 'fingerprintjs';

/* istanbul ignore next */
export function getBrowserFingerprint() {
  return new FingerPrint().get();
}
